import React from "react";
import { Helmet } from "react-helmet";
import "./Contact.css";

export const Contact = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/contact`;
  const description = "Contact FlintHost for sales, support, and setup help. Reach us via Discord, tickets, or email.";
  return (
    <div className="contact-page">
      <Helmet>
        <title>FlintHost | Contact</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Contact" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Contact" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <section className="contact-hero">
        <div className="contact-hero-content">
          <p className="contact-eyebrow">Support &amp; Sales</p>
          <h1>Contact FlintHost</h1>
          <p>
            Tell us what you need and we’ll get you set up fast. Choose the channel that works best for your request and our team will jump in.
          </p>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-grid">
          <div className="contact-card">
            <span className="contact-badge">Fastest</span>
            <h2>Discord</h2>
            <p>Chat with our team and community for quick answers, setup help, and general questions.</p>
            <a className="contact-link" href="https://discord.flinthost.com" target="_blank" rel="noopener noreferrer">
              Join Discord
            </a>
          </div>
          <div className="contact-card">
            <h2>Support tickets</h2>
            <p>Open a ticket for billing questions, technical support, or account help.</p>
            <a className="contact-link" href="https://billing.flinthost.com/tickets" target="_blank" rel="noopener noreferrer">
              Open a ticket
            </a>
          </div>
          <div className="contact-card">
            <h2>Email</h2>
            <p>Prefer email? Send your request and we’ll follow up with the next steps.</p>
            <a className="contact-link" href="mailto:contact@flinthost.com">
              contact@flinthost.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
